import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors } from '@/styles'
import { UnverifiedIcon } from '@/components/icons'
import { Label } from '@/components/text'

const UnverifiedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.yellow96};
  border-radius: 8px;
  flex-shrink: 0;
  padding: 6px 8px;
  color: ${colors.yellow24};
`

const StyledUnverifiedIcon = styled(UnverifiedIcon)`
  margin-right: 3px;
  width: 16px;
  height: 14px;
  flex-shrink: 0;
`

const UnverifiedBadge = () => {
  const { t } = useTranslation()
  return (
    <UnverifiedContainer>
      <StyledUnverifiedIcon />
      <Label fontSize="10px">
        {t('b.component.view.unverified.text', 'Unverified')}
      </Label>
    </UnverifiedContainer>
  )
}

export default UnverifiedBadge
